module.exports = __webpack_public_path__ + "static/media/taetigkeitsfelder.18ce70c8.jpg";